(function () {
  "use strict";

  angular.module("sempraWebapp").component("operationCounters", {
    templateUrl:
      "app/facilityKarcherDetails/operationCounters/operationCounters.html",
    controller: operationCounters,
    bindings: {
      operationCountersList: "<",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function operationCounters() {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.convertToInt = function(data) {
      return parseInt(data);
    }
  }
})();
